import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getJccSubscription, getPayPalSubscription } from '../../services/api';
import '../settings/Settings.css';

const OwOwnerPaymentResult = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { authenticatedFetch } = useAuth();
  const paypalOrderId = params.get('token');
  const jccOrderId = params.get('orderId');
  const orderId = paypalOrderId || jccOrderId;
  const [isSuccess, setIsSuccess] = useState(orderId ? null : false);
  const plan = params.get('plan') || 'your subscription';

  useEffect(() => {
    if (!orderId) return;
    const verify = jccOrderId ? getJccSubscription : getPayPalSubscription;
    verify(orderId, authenticatedFetch)
      .then((order) => setIsSuccess(order.status === 'completed'))
      .catch(() => setIsSuccess(false));
  }, [orderId, jccOrderId, authenticatedFetch]);

  if (isSuccess === null) return <div className="settings-page ph-no-capture">Verifying payment...</div>;

  return (
    <div className="settings-page ph-no-capture">
      <div className="settings-wrapper">
        <div className="settings-card">
          <div className="subscription-active-message">
            <div className="subscription-active-icon">
              {isSuccess ? (
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#81C784" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              ) : (
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#f6ad55" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
              )}
            </div>
            <h3 className="subscription-active-title">
              {isSuccess ? 'Payment Successful' : 'Payment Cancelled'}
            </h3>
            <p className="subscription-active-text">
              {isSuccess
                ? `Thank you! Your payment for ${plan} was received. Your subscription is now active.`
                : `Your payment for ${plan} was cancelled. No charge was made.`}
            </p>
            <button
              type="button"
              className="subscription-modal-btn subscription-modal-btn-confirm"
              onClick={() => navigate('/restaurant/settings')}
            >
              Back to Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwOwnerPaymentResult;
